import React from 'react';
import AppShell from '../shell/AppShell';
import PrivacyPolicyPage from '../../screens/PrivacyPolicyPage';

/**
 * /unified/privacy-policy — privacy policy inside the unified shell. Public
 * page, no auth gate.
 */
export default function UnifiedPrivacy() {
  return (
    <AppShell dense>
      <div className="cwm-unified-mui-wrap">
        <PrivacyPolicyPage />
      </div>
    </AppShell>
  );
}
